const CACHE_TTL_MS = 2 * 60 * 1000;

const readCache = (key) => {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (!parsed?.savedAt || Date.now() - parsed.savedAt > CACHE_TTL_MS) {
      sessionStorage.removeItem(key);
      return null;
    }
    return parsed.data;
  } catch {
    return null;
  }
};

const writeCache = (key, data) => {
  try {
    sessionStorage.setItem(key, JSON.stringify({
      savedAt: Date.now(),
      data,
    }));
  } catch {
    // Ignore quota errors — network fetch still works.
  }
};

export const PARTNER_MY_PROJECTS_CACHE_KEY = 'partner-portal:my-projects';
export const PARTNER_PAE_QUEUE_CACHE_KEY = 'partner-portal:pae-queue';

export const readPartnerProjectListCache = (key) => readCache(key);

export const writePartnerProjectListCache = (key, data) => writeCache(key, data);
